import { useState } from 'react';
import axios from '../config/axiosConfig';
import Cookies from 'js-cookie';

const usePostData = (url) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);

    const postData = async (formData) => {
        setIsLoading(true);
        setError(null);
        setData(null);
    
        const csrftoken = Cookies.get('csrftoken');
    
        try {
            const response = await axios.post(url, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrftoken
                }
            });

            // Assuming successful response status codes are 200 and 201
            if (response.status === 200 || response.status === 201) {
                setData(response.data);
                return { success: true, data: response.data };
            } else {
                const unexpectedSuccessMessage = "Received unexpected success response";
                setError(unexpectedSuccessMessage);
                return { success: false, error: unexpectedSuccessMessage };
            }
        } catch (err) {
            let errorMessage;
            if (err.response && err.response.data) {
                // Server responded with a specific error message
                errorMessage = err.response.data.error || err.response.data.detail || "مشکلی پیش آمده است";
            } else {
                // Generic error message for network issues or other errors
                errorMessage = err.message || "Network error";
            }
        
            setError(errorMessage);
            return { success: false, error: errorMessage };
        } finally {
            setIsLoading(false);
        }
    };

    return [postData, isLoading, data, error];
};

export default usePostData;
